module.exports = __webpack_public_path__ + "static/media/state2021.0a221dbd.jpeg";